module.exports = __webpack_public_path__ + "img/8.eefb6de5.svg";